import * as React from 'react';
import { Btn, useButton } from '../../../hooks/useButton';
import styled from '@emotion/styled';
import { Font } from '../../../fonts';

export interface SidebarButtonWidgetProps extends Btn {}

export const SidebarButtonWidget: React.FC<SidebarButtonWidgetProps> = (props) => {
  let button = useButton(props);
  return <S.Container {...button}>{props.label}</S.Container>;
};
namespace S {
  export const Container = styled.div`
    color: ${(p) => p.theme.text.primary};
    padding: 10px;
    cursor: pointer;
    font-family: ${Font.Special};
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  `;
}
